import { Component, AfterViewInit, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

declare var amp;
@Component({
  selector: 'app-half-saree',
  templateUrl: './half-saree.component.html',
  styleUrls: ['./half-saree.component.scss']
})
export class HalfSareeComponent implements AfterViewInit, OnInit, OnDestroy {

  windowsWidth;
  buttonShare = false;
  facebookUrl = '';
  myPlayer;

  constructor(
    public meta: Meta, public title: Title
  ) { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.goBackToTop();
    this.facebookUrl = window.location.href;
  }

  ngAfterViewInit() {
    const myOptions = {
      nativeControlsForTouch: false,
      logo: { 'enabled': false },
      controls: true,
      autoplay: false,
    };

    this.myPlayer = amp('azuremediaplayerHalfSaree', myOptions);
    this.myPlayer.src([
      {
        'src': 'https://mmtv-mmtv.streaming.mediaservices.windows.net/c9a2c1f7-e646-4ba5-b775-c7d3239b1a53/Half_Saree2.ism/manifest',
        'type': 'application/vnd.ms-sstr+xml'
      }
    ]);
  }

  ngOnDestroy(){
    this.myPlayer.dispose();
  }

  gotoTop() {
    document.getElementById('parentWrap').scrollTo({'top': 0, behavior: 'smooth'});
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopup').style.display = 'flex';
    } else {
      document.getElementById('sharePopup').style.display = 'none';
    }
  }

}
